import styles from "./index.module.scss";
import { useEffect, useState, useRef } from "react";
import bgImage from "./bg.jpg";
import {
  Tabs,
  Form,
  Input,
  Button,
  Spin,
  Modal,
  message,
} from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import Api from "../../api/index.js";
import WechatPhoneBindModal from "../../components/WechatPhoneBindModal";
import {
  resetPasswordFunction,
  phoneLoginFunction,
  passwordLoginFunction,
} from "./loginUtilsFunc.js";
import logo from "./logo.png";
import logo2 from "./aiLogo.png";
import {
  MCP_REQUEST_OPTIONS,
  readMcpContext,
  isCurrentMcpRequest,
  readMainSession,
  captureMainSession,
  isMainSessionCurrent,
  saveMainSession,
  clearMainSession,
  loadMcpMainPrefix,
  resolveMcpLogin,
  saveMcpLoginResume,
  clearMcpLoginResume,
  getMcpApprovalRecord,
  completeMcpApproval,
  mcpAuthorizationError,
} from "../../utils/mcpOAuth";
import {
  WECHAT_QR_EXPIRED_CODE,
  createQrPoller,
  getApiPayload,
} from "../../utils/wechatQr.js";
import { useCountdown } from '../../hooks/useCountdown'

const ResetPasswordForm = (props) => {
  const { onFinish, getCaptchaFunc, resetPasswordFunction } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { remaining, start } = useCountdown('resetPasswordCountdownSecond');

  const handleSubmit = () => {
    if (loading) {
      return;
    }
    form
      .validateFields()
      .then(async (values) => {
        setLoading(true);
        const res = await resetPasswordFunction(values);
        if (res.success) {
          message.success("重置成功");
          onFinish();
        } else {
          message.error(res.msg);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleGetCaptcha = () => {
    form
      .validateFields(["phone"])
      .then((res) => {
        const { phone } = res;
        getCaptchaFunc(phone, "retrieve_password");
        start();
      })
      .catch((error) => {});
  };

  return (
    <Form
      name="resetPasswordForm"
      autoComplete="off"
      className="resetPasswordForm"
      form={form}
    >
      <Form.Item
        label="手机号"
        name="phone"
        rules={[
          { required: true, message: "请输入手机号" },
          {
            pattern:
              /^(13\d|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18\d|19[0-35-9])\d{8}$/,
            message: "手机号格式不对",
          },
        ]}
      >
        <Input
          allowClear
          prefix={
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-phone-icon lucide-phone"
            >
              <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
            </svg>
          }
          className="loginFormInput"
          placeholder="请输入手机号"
          type="tel"
          autocomplete="tel"
        />
      </Form.Item>
      <Form.Item
        label="验证码"
        name="captcha"
        rules={[
          { required: true, message: "请输入验证码" },
          { pattern: /^[0-9]\d{5}$/, message: "验证码格式不对" },
        ]}
      >
        <Input
          allowClear
          prefix={
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-key-round-icon lucide-key-round"
            >
              <path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z" />
              <circle cx="16.5" cy="7.5" r=".5" fill="currentColor" />
            </svg>
          }
          className="loginFormInput"
          placeholder="请输入验证码"
          suffix={
            remaining < 60 ? (
              <div className="loginFormInputCaptchaBtn">
                {remaining}s后重试
              </div>
            ) : (
              <div
                className="loginFormInputCaptchaBtn"
                onClick={handleGetCaptcha}
              >
                获取验证码
              </div>
            )
          }
        />
      </Form.Item>
      <Form.Item
        label="新密码"
        name="password"
        rules={[
          { required: true, message: "新密码不能为空" },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value) {
                return Promise.resolve();
              }
              if (value?.length < 8 || value?.length > 16) {
                return Promise.reject(
                  new Error("8-16位，至少包含数字/字母/字符两种组合"),
                );
              }
              let reg =
                /((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z]))(?!^.*[\u4E00-\u9FA5].*$)^\S{8,16}$/;
              if (!reg.test(value)) {
                return Promise.reject(
                  new Error("8-16位，至少包含数字/字母/字符两种组合"),
                );
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <Input
          allowClear
          prefix={<LockOutlined />}
          className="loginFormInput"
          placeholder="请输入密码"
          autoComplete="new-password"
        />
      </Form.Item>
      <button
        type="submit"
        className="loginFormSubmitBtn"
        onClick={handleSubmit}
      >
        重置密码
      </button>
    </Form>
  );
};

const PasswordFrom = (props) => {
  const { onFinish, getCaptchaFunc, resetPasswordFunction, loading } = props;
  const [form] = Form.useForm();
  const [resetPasswordOpen, setResetPasswordOpen] = useState(false);

  const handleSubmit = (values) => {
    if (loading) return;
    onFinish(values);
  };

  const resetPasswordSuccess = (values) => {
    setResetPasswordOpen(false);
  };

  return (
    <>
      <Form
        name="accountForm"
        autoComplete="off"
        className="accountForm"
        form={form}
        onFinish={handleSubmit}
      >
        <Form.Item
          label={null}
          name="username"
          rules={[
            {
              required: true,
              message: "请输入账号",
            },
          ]}
        >
          <Input
            allowClear
            prefix={<UserOutlined />}
            className="loginFormInput"
            placeholder="请输入账号"
          />
        </Form.Item>
        <Form.Item
          label={null}
          name="password"
          rules={[
            {
              required: true,
              message: "请输入密码",
            },
          ]}
        >
          <Input.Password
            allowClear
            prefix={<LockOutlined />}
            className="loginFormInput"
            placeholder="请输入密码"
          />
        </Form.Item>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Button
            type="link"
            style={{ fontSize: "14px", padding: 0 }}
            onClick={() => {
              setResetPasswordOpen(true);
            }}
          >
            忘记密码?
          </Button>
        </div>
        <button
          type="submit"
          className="loginFormSubmitBtn"
          disabled={loading}
        >
          登录并授权
        </button>
      </Form>

      <Modal
        title="重置密码"
        wrapClassName="mcpLoginResetPasswordModal"
        open={resetPasswordOpen}
        centered
        onCancel={() => setResetPasswordOpen(false)}
        footer={null}
        destroyOnClose={true}
      >
        <ResetPasswordForm
          resetPasswordFunction={resetPasswordFunction}
          onFinish={resetPasswordSuccess}
          getCaptchaFunc={getCaptchaFunc}
        ></ResetPasswordForm>
      </Modal>
    </>
  );
};

const PhoneForm = (props) => {
  const { onFinish, getCaptchaFunc, loading } = props;
  const [form] = Form.useForm();
  const { remaining, start } = useCountdown('countdownSecond');

  const handleSubmit = (values) => {
    if (loading) return;
    onFinish(values);
  };

  const handleGetCaptcha = () => {
    form
      .validateFields(["phone"])
      .then((res) => {
        const { phone } = res;
        getCaptchaFunc(phone, 2);
        start();
      })
      .catch((error) => {});
  };

  return (
    <Form name="phoneForm" autoComplete="off" className="phoneForm" form={form} onFinish={handleSubmit}>
      <Form.Item
        label={null}
        name="phone"
        rules={[
          {
            required: true,
            message: "请输入手机号",
          },
          {
            pattern:
              /^(13\d|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18\d|19[0-35-9])\d{8}$/,
            message: "手机号格式不对",
          },
        ]}
      >
        <Input
          allowClear
          prefix={
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-phone-icon lucide-phone"
            >
              <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
            </svg>
          }
          className="loginFormInput"
          placeholder="请输入手机号"
          type="tel"
          autocomplete="tel"
        />
      </Form.Item>
      <Form.Item
        label={null}
        name="captcha"
        rules={[
          {
            required: true,
            message: "请输入验证码",
          },
          { pattern: /^[0-9]\d{5}$/, message: "验证码格式不对" },
        ]}
      >
        <Input
          allowClear
          prefix={
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-key-round-icon lucide-key-round"
            >
              <path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z" />
              <circle cx="16.5" cy="7.5" r=".5" fill="currentColor" />
            </svg>
          }
          className="loginFormInput"
          placeholder="请输入验证码"
          suffix={
            remaining < 60 ? (
              <div className="loginFormInputCaptchaBtn">
                {remaining}s后重试
              </div>
            ) : (
              <div
                className="loginFormInputCaptchaBtn"
                onClick={handleGetCaptcha}
              >
                获取验证码
              </div>
            )
          }
        />
      </Form.Item>

      <button
        type="submit"
        className="loginFormSubmitBtn"
        disabled={loading}
      >
        登录并授权
      </button>
    </Form>
  );
};

const QrFrom = (props) => {
  const { getQrFunc, onFinish, onPhoneBinding, getSessionSnapshot } = props;
  const [qrUrl, setQrUrl] = useState(null);
  const pollerRef = useRef(null);
  const qrRequestRef = useRef(0);
  const [isOverdue, setIsOverdue] = useState(false);
  const [imgLoading, setImgLoading] = useState(false);

  const stopPolling = () => {
    pollerRef.current?.stop();
    pollerRef.current = null;
  };

  //刷新二维码
  const refreshRQ = async () => {
    const sessionSnapshot = getSessionSnapshot();
    const requestId = qrRequestRef.current + 1;
    qrRequestRef.current = requestId;
    stopPolling();
    setIsOverdue(false);
    setImgLoading(true);
    try {
      const res = await getQrFunc();
      if (requestId !== qrRequestRef.current) return;
      if (res.data.code !== 0) {
        message.error(res.data.msg);
        return;
      }
      const data = getApiPayload(res);
      setQrUrl(data?.qrcode || "");
      const poller = createQrPoller({
        poll: (token) => Api.getTokenByPollToken(token, MCP_REQUEST_OPTIONS),
        isComplete: (result) =>
          Boolean(
            result?.ticket ||
            result?.token ||
            result?.token_response ||
            result?.status === "phone_binding_required",
          ),
        onComplete: (result) => {
          if (result?.status === "phone_binding_required") {
            onPhoneBinding(data?.poll_token, sessionSnapshot);
          } else {
            onFinish(result, sessionSnapshot);
          }
        },
        onExpired: () => {
          stopPolling();
          setIsOverdue(true);
          message.error("二维码或登录凭证已过期，请刷新二维码");
        },
        onError: (msg, code) => {
          if (code !== WECHAT_QR_EXPIRED_CODE && msg) message.error(msg);
        },
      });
      pollerRef.current = poller;
      poller.start(data?.poll_token, data?.expires_in);
    } catch (_) {
      if (requestId === qrRequestRef.current) {
        message.error("二维码加载失败，请稍后重试");
      }
    } finally {
      if (requestId === qrRequestRef.current) setImgLoading(false);
    }
  };

  useEffect(() => {
    refreshRQ();
    return () => {
      qrRequestRef.current += 1;
      stopPolling();
    };
    // 二维码组件挂载时创建一次，卸载时统一停止轮询。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="qrForm">
      <div className="qrFormImg">
        {isOverdue && (
          <div className="overdueBox" onClick={refreshRQ}>
            <svg
              t="1701152961032"
              viewBox="0 0 1024 1024"
              version="1.1"
              p-id="5490"
              width="34"
              height="34"
            >
              <path
                d="M512 919.552c-224.768 0-407.552-182.784-407.552-407.552 0-8.704 0.512-17.408 1.024-26.112l71.68 4.608c-0.512 7.168-0.512 14.336-0.512 21.504 0 185.344 150.528 335.872 335.872 335.872 86.528 0 168.448-32.768 230.912-92.16l49.152 52.224C716.288 880.128 616.96 919.552 512 919.552zM919.552 512h-71.68c0-11.776-0.512-23.552-2.048-35.328-17.92-171.52-161.28-300.544-334.336-300.544-67.584 0-132.096 19.968-187.904 57.344L284.16 174.08c67.072-45.568 145.92-69.632 227.84-69.632 209.408 0 384 156.672 405.504 365.056 1.536 13.824 2.048 28.16 2.048 42.496z"
                p-id="5491"
              ></path>
              <path
                d="M140.288 290.816L28.16 491.52c-3.072 5.12 1.024 11.776 6.656 11.776H258.56c6.144 0 9.728-6.144 6.656-11.776L153.6 290.816c-3.072-5.632-10.752-5.632-13.312 0zM870.4 675.84L758.272 475.136c-3.072-5.12 1.024-11.776 6.656-11.776h223.744c6.144 0 9.728 6.144 6.656 11.776L883.712 675.84c-2.56 5.12-10.24 5.12-13.312 0zM270.336 202.24a35.84 35.84 0 1 0 71.68 0 35.84 35.84 0 1 0-71.68 0zM728.576 784.896a35.84 35.84 0 1 0 71.68 0 35.84 35.84 0 1 0-71.68 0z"
                p-id="5492"
              ></path>
            </svg>
          </div>
        )}
        {imgLoading ? (
          <div className="imgLoadingBox">
            <Spin size="large"></Spin>
          </div>
        ) : (
          <img src={qrUrl} alt="请扫描二维码" />
        )}
      </div>
      <div className="qrFormTip">
        {!isOverdue ? `请使用微信扫描二维码登录` : "二维码已失效，点击刷新"}
      </div>
    </div>
  );
};

const Metric = ({ icon, label, desc }) => {
  return (
    <div className={styles.metricCard}>
      <div className={styles.metricIcon}>{icon}</div>
      <div className={styles.metricLabel}>{label}</div>
      <div className={styles.metricDesc}>{desc}</div>
    </div>
  );
};

export default function McpLogin() {
  const [formType, setFormType] = useState("account");
  const [bindingPollToken, setBindingPollToken] = useState("");
  const [qrGeneration, setQrGeneration] = useState(0);
  const [context] = useState(() => {
    if (window !== window.top) return { error: "请在浏览器顶层页面打开授权链接。" };
    try { return readMcpContext(); }
    catch (_) { return { error: "授权链接或登录恢复信息无效，请从 WorkBuddy 重新发起。" }; }
  });
  const [isAuthorizing, setIsAuthorizing] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [ready, setReady] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [errorText, setErrorText] = useState(context.error || "");
  const prefixRef = useRef();
  const activeRef = useRef(false);
  const busyRef = useRef(false);
  const completedRef = useRef(false);
  const callbackRef = useRef("");
  const callbackSessionRef = useRef(null);
  const bindingSessionRef = useRef(null);
  const silentPollerRef = useRef(null);
  const silentPollingRef = useRef(false);

  const isActiveRequest = () => activeRef.current && !context.error && isCurrentMcpRequest(context);

  const showError = (text) => {
    if (!activeRef.current) return;
    setErrorText(text);
    message.error(text);
  };

  const stopSilentPolling = () => {
    silentPollingRef.current = false;
    if (silentPollerRef.current) {
      clearTimeout(silentPollerRef.current);
      silentPollerRef.current = null;
    }
  };

  const sessionChanged = () => {
    stopSilentPolling();
    completedRef.current = false;
    callbackRef.current = "";
    callbackSessionRef.current = null;
    bindingSessionRef.current = null;
    busyRef.current = false;
    setCompleted(false);
    setBindingPollToken("");
    setIsLogin(Boolean(readMainSession(prefixRef.current)));
    showError("登录状态已变化，本次操作已停止，请重新点击授权登录或重新登录。");
  };

  const checkSession = (snapshot) => {
    if (isMainSessionCurrent(snapshot, prefixRef.current)) return true;
    sessionChanged();
    return false;
  };

  const requireLogin = (text, snapshot) => {
    stopSilentPolling();
    if (!clearMainSession(prefixRef.current, snapshot)) { sessionChanged(); return; }
    setIsLogin(false);
    try { saveMcpLoginResume(context.originalUrl); }
    catch (_) { showError("无法保存登录恢复信息，请允许浏览器会话存储后重新登录。"); return; }
    showError(text);
  };

  const submitApproval = async (expectedSession) => {
    if (!isActiveRequest()) return;
    const snapshot = captureMainSession(prefixRef.current);
    const session = readMainSession(prefixRef.current);
    if (!session) {
      requireLogin("未取得 Main 登录凭据，请先登录。", snapshot);
      return;
    }
    if (expectedSession && session.token !== expectedSession.token) {
      sessionChanged();
      return;
    }
    setIsAuthorizing(true);
    setErrorText("");
    try {
      const record = await getMcpApprovalRecord(context.originalUrl, session.userId);
      if (!isActiveRequest()) return;
      if (!checkSession(snapshot)) return;
      if (record.completed) {
        showError("本次授权已完成，请返回 WorkBuddy；如需重新授权，请从客户端重新发起。");
        return;
      }
      const res = await Api.authorizeMcp({
        ...context.params,
        decision: "approve",
        idempotency_key: record.key,
      }, session.token);
      if (!isActiveRequest()) return;
      if (!checkSession(snapshot)) return;
      const body = res?.data;
      if (!(res?.status >= 200 && res.status < 300) || body?.code !== 0) {
        if (body?.code === 3 || body?.code === 11003) requireLogin(mcpAuthorizationError(body.code), snapshot);
        else showError(mcpAuthorizationError(body?.code));
        return;
      }
      const callbackUrl = body.data?.callback_url;
      if (typeof callbackUrl !== "string" || !callbackUrl.trim()) {
        showError("授权响应缺少回调地址，结果可能未知。请使用原请求重试。");
        return;
      }
      callbackRef.current = callbackUrl;
      callbackSessionRef.current = snapshot;
      completedRef.current = true;
      setCompleted(true);
      completeMcpApproval(record);
      clearMcpLoginResume();
      window.location.assign(callbackUrl);
    } catch (error) {
      if (!isActiveRequest()) return;
      if (!checkSession(snapshot)) return;
      if (error?.response?.status === 401) requireLogin(mcpAuthorizationError(3), snapshot);
      else if (completedRef.current) showError("浏览器未能打开客户端，请点击继续返回 WorkBuddy。");
      else showError("授权请求未完成，结果可能未知。重试将保留原幂等键；请使用 HTTPS 并允许浏览器会话存储。");
    } finally {
      if (activeRef.current) setIsAuthorizing(false);
    }
  };

  const authorizationFunc = async () => {
    if (busyRef.current || completedRef.current || !ready || !isActiveRequest()) return;
    busyRef.current = true;
    stopSilentPolling();
    try { await submitApproval(); }
    finally { busyRef.current = completedRef.current; }
  };

  const finishLogin = async (data, approve, snapshot, allowed = isActiveRequest) => {
    const result = await resolveMcpLogin(data, context.originalUrl);
    if (!allowed()) return;
    if (!checkSession(snapshot)) return;
    if (result.loginUrl) {
      // shortcut: 外部 SSO 无法证明跨页同意意图，具备可靠关联机制前恢复后等待点击授权。
      saveMcpLoginResume(context.originalUrl);
      window.location.assign(result.loginUrl);
      return;
    }
    if (!saveMainSession(result.session, prefixRef.current, snapshot)) { sessionChanged(); return; }
    clearMcpLoginResume();
    setIsLogin(true);
    if (approve) await submitApproval(result.session);
  };

  // 静默 Ticket 在本页兑换，不经过产品/菜单门禁，且绝不延续自动同意。
  const runSilentLoginTick = async () => {
    silentPollerRef.current = null;
    if (!silentPollingRef.current) return false;

    try {
      if (readMainSession(prefixRef.current)) {
        stopSilentPolling();
        setIsLogin(true);
        return true;
      }
      const snapshot = captureMainSession(prefixRef.current);
      const res = await Api.silentLogin(MCP_REQUEST_OPTIONS);
      if (!silentPollingRef.current || !isActiveRequest()) return false;
      if (!checkSession(snapshot)) return false;
      if (res?.data?.code === 0 && res.data.data?.ticket) {
        await finishLogin(res.data.data, false, snapshot, () => silentPollingRef.current && isActiveRequest());
        stopSilentPolling();
        return true;
      }
    } catch (_) {
      // 静默失败保留手动登录表单，不输出凭据或网络响应。
    }

    //未命中，继续下一轮
    if (silentPollingRef.current && isActiveRequest()) {
      silentPollerRef.current = setTimeout(runSilentLoginTick, 3000);
    }
    return false;
  };

  useEffect(() => {
    localStorage.removeItem("AutoLoginUserInfo");
    activeRef.current = true;
    const initialize = async () => {
      if (context.error) return;
      try {
        const prefix = await loadMcpMainPrefix();
        if (!isActiveRequest()) return;
        prefixRef.current = prefix;
        setReady(true);
        if (context.ticket || context.loginCode) {
          busyRef.current = true;
          setLoginLoading(true);
          window.history.replaceState(window.history.state, "", context.originalUrl);
          await finishLogin({ ticket: context.ticket, loginCode: context.loginCode }, false, captureMainSession(prefix));
        } else if (readMainSession(prefix)) {
          clearMcpLoginResume();
          setIsLogin(true);
        } else {
          silentPollingRef.current = true;
          runSilentLoginTick();
        }
      } catch (_) {
        showError("Main 登录配置或凭证恢复失败，请重新登录或重新打开授权页面。");
      } finally {
        busyRef.current = false;
        if (activeRef.current) setLoginLoading(false);
      }
    };
    initialize();
    return () => {
      activeRef.current = false;
      stopSilentPolling();
    };
    // 每次 OAuth URL 变化由路由 key 重新挂载，旧异步回调不能继续授权。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (values) => {
    if (!values || busyRef.current || completedRef.current || !ready || !isActiveRequest()) return;
    busyRef.current = true;
    stopSilentPolling();
    setLoginLoading(true);
    setErrorText("");
    const snapshot = captureMainSession(prefixRef.current);
    try {
      const res = formType === "account"
        ? await passwordLoginFunction(values)
        : await phoneLoginFunction(values);
      if (!isActiveRequest()) return;
      if (!checkSession(snapshot)) return;
      if (!res.success) { showError(res.msg || "登录失败，请重试。"); return; }
      // 意图仅存在于这次用户提交的调用栈，不写入刷新可复用的标记。
      await finishLogin(res.data, true, snapshot);
    } catch (error) {
      showError(error?.isAxiosError ? "登录请求失败，请稍后重试。" : error.message || "登录失败，请重试。");
    } finally {
      busyRef.current = completedRef.current;
      if (activeRef.current) setLoginLoading(false);
    }
  };

  const handleQrLogin = async (values, snapshot) => {
    if (busyRef.current || completedRef.current || !ready || !isActiveRequest()) return;
    if (!checkSession(snapshot)) return;
    busyRef.current = true;
    stopSilentPolling();
    setBindingPollToken("");
    setLoginLoading(true);
    try { await finishLogin(values, false, snapshot); }
    catch (_) {
      showError("扫码登录未取得 Main 凭据，请重新扫码或使用密码、短信登录。");
      setQrGeneration(generation => generation + 1);
    } finally {
      busyRef.current = false;
      if (activeRef.current) setLoginLoading(false);
    }
  };

  const onTabsChange = (type) => {
    setFormType(type);
  };

  //获取验证码
  const getCaptchaFunc = (phoneNumber, type) => {
    Api.getVerifyCode({
      phone: phoneNumber,
      type,
    }, MCP_REQUEST_OPTIONS).then(res => {
      if (res?.data?.code !== 0) showError("验证码发送失败，请稍后重试。");
    }).catch(() => showError("验证码发送失败，请稍后重试。"));
  };

  //获取二维码
  const getQrFunc = () => {
    return Api.getQRCodeUrl("2", "SYS", MCP_REQUEST_OPTIONS);
  };

  return (
    <div className={styles.root}>
      <div className={styles.grid}>
        {/* Left branded panel */}
        <section
          className={styles.leftPanel}
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className={styles.leftOverlay} />
          <div className={styles.leftContent}>
            {/* Logo */}
            <div className={styles.logoWrap}>
              <div className={styles.logoIcon}>
                <img src={logo} alt="" />
              </div>
              {/* <span className={styles.logoText}>金融Ai助手</span> */}
            </div>

            {/* Hero text */}
            <div className={styles.heroText}>
              <div className={styles.badge}>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-sparkles-icon lucide-sparkles"
                >
                  <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
                  <path d="M20 2v4" />
                  <path d="M22 4h-4" />
                  <circle cx="4" cy="20" r="2" />
                </svg>
                <span>金融数据服务</span>
              </div>
              <h1 className={styles.heroTitle}>
                吾道MCP：面向AI应用的资本数据服务
              </h1>
              <p className={styles.heroDesc}>
                覆盖项目与市场统计、公司关系、风险记录、监管动态与新闻舆情，通过MCP标准协议开放，供AI应用与智能体调用
              </p>
            </div>

            {/* Metrics */}
            <div className={styles.metrics}>
              <Metric
                icon={
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 3V21H21M7 17V13M12 17V9M17 17V11M6 9L12 4L16 7L21 2M21 6V2H17"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke="#BEDBFF"
                    />
                  </svg>
                }
                label="资本运作与市场"
                desc="资本运作项目进程与审核、发行定价与申购获配、募资与机构排名"
              />
              <Metric
                icon={
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 3V7M12 7V20M12 7H5M12 7H19M8 21H16M4 7H5M5 7L2 14H8L5 7ZM19 7H20M19 7L16 14H22L19 7Z"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke="#BEDBFF"
                    />
                    <path
                      d="M2 14C2 14.7956 2.31607 15.5587 2.87868 16.1213C3.44129 16.6839 4.20435 17 5 17C5.79565 17 6.55871 16.6839 7.12132 16.1213C7.68393 15.5587 8 14.7956 8 14M16 14C16 14.7956 16.3161 15.5587 16.8787 16.1213C17.4413 16.6839 18.2044 17 19 17C19.7956 17 20.5587 16.6839 21.1213 16.1213C21.6839 15.5587 22 14.7956 22 14"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke="#BEDBFF"
                    />
                  </svg>
                }
                label="诉讼与处罚"
                desc="诉讼、执行与失信，担保与票据逾期，行政处罚与监管措施"
              />
              <Metric
                icon={
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    fill="none"
                    class="lucide lucide-shield-check-icon lucide-shield-check"
                  >
                    <g clip-path="url(#clip0_4819_2638)">
                      <path
                        d="M10.5 2H13.5C14.3284 2 15 2.67157 15 3.5V6.5C15 7.32843 14.3284 8 13.5 8H10.5C9.67157 8 9 7.32843 9 6.5V3.5C9 2.67157 9.67157 2 10.5 2Z"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke="#BEDBFF"
                      />
                      <path
                        d="M3.5 16H6.5C7.32843 16 8 16.6716 8 17.5V20.5C8 21.3284 7.32843 22 6.5 22H3.5C2.67157 22 2 21.3284 2 20.5V17.5C2 16.6716 2.67157 16 3.5 16Z"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke="#BEDBFF"
                      />
                      <path
                        d="M17.5 16H20.5C21.3284 16 22 16.6716 22 17.5V20.5C22 21.3284 21.3284 22 20.5 22H17.5C16.6716 22 16 21.3284 16 20.5V17.5C16 16.6716 16.6716 16 17.5 16Z"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke="#BEDBFF"
                      />
                      <path
                        d="M12 8V12M12 12H5V16M12 12H19V16"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke="#BEDBFF"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4819_2638">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                }
                label="关联方与股权"
                desc="股东、对外投资与董监高任职，穿透股权结构与人员关系"
              />
              <Metric
                icon={
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-chart-column-icon lucide-chart-column"
                  >
                    <g clip-path="url(#clip0_4819_2650)">
                      <path
                        d="M5 3H6M6 3H20C20.2652 3 20.5196 3.10536 20.7071 3.29289C20.8946 3.48043 21 3.73478 21 4V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.82987 21 4.66197 20.9783 4.5 20.9365M6 3V8M4.5 20.9365C4.15699 20.8479 3.84056 20.669 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8H6M4.5 20.9365C4.84301 20.8479 5.15944 20.669 5.41421 20.4142C5.78929 20.0391 6 19.5304 6 19V8M4.5 20.9365C4.33803 20.9783 4.17013 21 4 21"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke="#BEDBFF"
                      />
                      <path
                        d="M9.5 6H13.5C13.7761 6 14 6.22386 14 6.5V10.5C14 10.7761 13.7761 11 13.5 11H9.5C9.22386 11 9 10.7761 9 10.5V6.5C9 6.22386 9.22386 6 9.5 6Z"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke="#BEDBFF"
                      />
                      <path
                        d="M17 6H18M17 10H18M9 15H18M9 18H18"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke="#BEDBFF"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4819_2650">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                }
                label="新闻与舆情"
                desc="公告、政府与媒体报道，含主体、原文、分类及事件等信息提取"
              />
            </div>
          </div>
        </section>

        {/* Right form panel */}
        <section className={styles.rightPanel}>
          <div className={styles.formCard}>
            <div className={styles.formHeader}>
              <div className={styles.formIcon}>
                <img src={logo2} alt="" srcset="" />
              </div>
              <h2 className={styles.formTitle}>授权 WorkBuddy</h2>
              <p className={styles.formSubtitle}>
                登录后将允许该应用代表你查询 IWUDAO 金融数据库
              </p>
            </div>
            {errorText && <p role="alert" style={{ color: "#ff4d4f" }}>{errorText}</p>}
            {completed ? (
              <div className={styles.authorizing}>
                <p>授权成功，正在跳转...</p>
                <Button onClick={() => {
                  if (isActiveRequest() && checkSession(callbackSessionRef.current)) window.location.assign(callbackRef.current);
                }}>继续返回 WorkBuddy</Button>
              </div>
            ) : isAuthorizing ? (
              <div className={styles.authorizing}>
                <Spin />
                <p>正在授权...</p>
              </div>
            ) : isLogin ? (
              <div className={styles.btnBox}>
                <Button
                  type="primary"
                  className="loginSubmitBtn"
                  loading={isAuthorizing}
                  disabled={!ready || loginLoading}
                  onClick={authorizationFunc}
                >
                  授权登录
                </Button>
                <Button
                  // type="primary"
                  className="logoutSubmitBtn"
                  onClick={() => {
                    setIsLogin(false);
                  }}
                >
                  退出登录
                </Button>
              </div>
            ) : (
              <>
                <div className={styles.form}>
                  <Tabs
                    onChange={onTabsChange}
                    activeKey={formType}
                    centered
                    className="mcpLoginFormTabs"
                  >
                    {/* 密码登录 */}
                    <Tabs.TabPane
                      tab={
                        <div style={{ width: "80px", textAlign: "center" }}>
                          密码登录
                        </div>
                      }
                      key="account"
                    >
                      <PasswordFrom
                        loading={!ready || loginLoading || Boolean(context.error)}
                        onFinish={handleSubmit}
                        getCaptchaFunc={getCaptchaFunc}
                        resetPasswordFunction={resetPasswordFunction}
                      ></PasswordFrom>
                    </Tabs.TabPane>
                    <Tabs.TabPane
                      tab={
                        <div style={{ width: "80px", textAlign: "center" }}>
                          手机号登录
                        </div>
                      }
                      key="captcha"
                    >
                      <PhoneForm
                        loading={!ready || loginLoading || Boolean(context.error)}
                        onFinish={handleSubmit}
                        getCaptchaFunc={getCaptchaFunc}
                      ></PhoneForm>
                    </Tabs.TabPane>
                    <Tabs.TabPane
                      tab={
                        <div style={{ width: "80px", textAlign: "center" }}>
                          扫码登录
                        </div>
                      }
                      key="qrcode"
                    >
                      {ready && !context.error && <QrFrom
                        key={qrGeneration}
                        onFinish={handleQrLogin}
                        getQrFunc={getQrFunc}
                        getSessionSnapshot={() => captureMainSession(prefixRef.current)}
                        onPhoneBinding={(pollToken, snapshot) => {
                          if (!isActiveRequest() || !checkSession(snapshot)) return;
                          bindingSessionRef.current = snapshot;
                          setBindingPollToken(pollToken);
                        }}
                      ></QrFrom>}
                    </Tabs.TabPane>
                  </Tabs>
                </div>

                <div className={styles.footerLine}></div>

                <div className={styles.disclaimer}>
                  登录即视为您已阅读并同意
                  <a href="/legal-agreement/wd_tos.html" target="_blank">
                    《服务协议》
                  </a>
                  和
                  <a href="/legal-agreement/wd_privacy.html" target="_blank">
                    《隐私协议》
                  </a>
                </div>
              </>
            )}
          </div>
        </section>
      </div>
      <WechatPhoneBindModal
        visible={Boolean(bindingPollToken)}
        pollToken={bindingPollToken}
        requestOptions={MCP_REQUEST_OPTIONS}
        onSuccess={(ticket) => handleQrLogin({ ticket }, bindingSessionRef.current)}
        onCancel={() => {
          setBindingPollToken("");
          setQrGeneration((generation) => generation + 1);
        }}
      />
    </div>
  );
}
